<!-- 此component用來個人帳號的瀏覽 -->
<template>
	<section>
	<div class="profile">
		<!-- left area -->
		<el-col id="profile-table" v-loading="loading" :span="6" class="profile-table">
			<div v-show="profileShow">
				<div class="profile-head"> 基本資料 </div>
				<div class="profile-item">
					<div class="profile-title"> 姓名 </div>
					<div class="profile-name"> {{profile.user.displayname}} </div>
				</div>
				<div class="profile-item">
					<div class="profile-title"> 帳號 </div>
					<div class="profile-name"> {{profile.user.username}} </div>
				</div>
				<div class="profile-item">
					<div class="profile-title"> 信箱 </div>
					<div class="profile-name"> {{profile.user.email}} </div>
				</div>
				<div v-if="!authorId" class="profile-item">
					<div class="profile-title"> 密碼 </div>
					<el-button v-if="!isResetPW" class="reset-btn" @click="resetPassword(true)">重設密碼</el-button>
					<div v-else>
						<div style="width : 100%; display: block; position: relative">
							<input id="password" 
										class="password-input" 
										:type="showPass ? 'text' : 'password'" 
										v-model="profile.newPW" 
										placeholder="請輸入新密碼" 
										v-on:keydown.enter.prevent='prevent'>
							<img :title="showPass? '顯示密碼': '隱藏密碼'" 
										@click="showPass=!showPass" 
										style="position: absolute; width: 20px; height: 20px; margin-top: 13px; margin-left: -25px; cursor: pointer;"
										:src="showPass?openeye:nopeneye">
						</div>
						<div style="width : 100%; display: block; position: relative">
							<input id="check-password" 
										class="password-input" 
										:type="showPass2 ? 'text' : 'password'" 
										v-model="profile.checkNewPW" 
										placeholder="請再一次輸入，以便確認" 
										v-on:keydown.enter.prevent='prevent'>
							<img :title="showPass2? '顯示密碼': '隱藏密碼'" 
										@click="showPass2=!showPass2" 
										style="position: absolute; width: 20px; height: 20px; margin-top: 13px; margin-left: -25px; cursor: pointer;"
										:src="showPass2?openeye:nopeneye">
						</div>
						<el-button class="save-btn" @click="savePassword">儲存</el-button>
						<el-button class="cancel-btn" @click="resetPassword(false)">取消</el-button>
					</div>
				</div>
				<div class="profile-item">
					<div class="profile-title"> 部門 </div>
					<div class="profile-name"> {{ profile.actual_dep.name + "(" + profile.dep.title  + ")" }} </div>
				</div>
				<div class="profile-item">
					<div class="profile-title"> 權限 </div>
					<div class="profile-name"> {{formatLevel(profile.level)}} </div>
				</div>
				<div class="profile-item">
					<div class="profile-title"> 身份 </div>
					<div class="profile-name"> {{formatManager(profile.isManager)}} </div>
				</div>
				<div style="color: transparent">
					Frontend vesrion: {{ frontendVersion  }} <br/>
					Backend Version: {{ backendVersion }}
				</div>
			</div>
		</el-col>
		<!-- right area -->
		<el-col :span="18">
		</el-col>
		<hint v-show="hint.display && this.$store.state.hintStatus.profile" :message="hint.message" @close="closeHint"></hint>  
	</div>
	</section>
</template>

<script>
	import API from '../../api/api';
	export default {
		name: 'Profile',
		data() {
			return {
				openeye: require('@/assets/icon/ic_eye.png'), 
				nopeneye: require('@/assets/icon/ic_remove_eye.png'),
				showPass: false,
				showPass2: false,
				profile: {
					user: {
						displayname: '',
						username: ''	
					},
					dep: {
						title:''
					},
					actual_dep: {
						name:''
					},
					level: '',
					isManager: '',
					newPW: '',
					checkNewPW: ''
				},
				loading: false,
				profileShow: false,
				isResetPW: false,
				authorId: null,
				//跳出hint
				hint: {
					message: '',
					display: false,
				},
				timer: null,
				frontendVersion: '',
				backendVersion: '',
			}
		},
		created() {
			this.loading = true;
			this.$store.state.nowStatus = 8;
			/*
			if(location.hash.split('/').length > 2) {
				this.authorId = location.hash.split('/')[2]
				this.profile.user.name = this.authorId;
			} else {
				this.profile.user.name = this.$store.state.userName;
			}
			*/
			//初始化
			this.initial();
		},
		methods: {
			/**
			  * initial 初始化
			  * @return none
			  */   
			initial: function() {
				API.getUser().then((result) => {
					if(result.status) {
						redirectLogin(result.data);
						if(!JSON.parse(result.request.response).error_msg) {
							this.showHint('取得使用者資訊錯誤!');
						} else {
							this.showHint(JSON.parse(result.request.response).error_msg);
						}
					} else {
						//update username
						this.$store.state.userName = result.name;
						//取得會員資訊
						API.accountInfo(this.$store.state.userName).then((response) => {
							if(response.status !== 0 && response.status !== 1) {
								if(!JSON.parse(response.request.response).error_msg) {
									this.showHint('取得使用者資訊錯誤!');
								} else {
									this.showHint(JSON.parse(response.request.response).error_msg);	
								}
							} else {
								this.$store.state.userDepId = response.depId;
								this.$store.state.userActualDepId = response.actual_depid;
								this.profile = response;
								if (this.profile.actual_dep == null) {
									this.profile.actual_dep = { name: "" };
								}
								this.profileShow = true;
							}
							this.loading = false;
						});	
					}
				});
				this.frontendVersion = process.env.APPLICATION_VERSION;
				API.getVersion().then((result) => {
						if (result.version) {
							this.backendVersion = result.version;
						}
					}
				);
			},
			/**
			  * formatLevel 權限轉換
			  * @param  {object}  level - level
			  * @return {string}  level - 權限
    		*/
			formatLevel: function (level) {	
				if(level === 1) {
					return "Level 1 (師2-師5)";
				} else if(level === 2) {
					return "Level 2 (師6-師11)";	
				} else if(level === 3) {
					return "Level 3 (師12以上)";	
				} else {
					return "";
				}
			},
			/**
			  * formatCtime 管理員轉換
			  * @param  {object} isManager - isManager
			  * @return {string} isManager - 是否管理者
    		*/
			formatManager: function (isManager) {	
				if(isManager === 1) {
					return "部門管理員";	
				} else if(isManager === 2) {
					return "系統管理員";	
				} else {
					return "一般";	
				}
			},
			/**
			  * resetPassword 重設密碼
				* @param  {bool} reset - 是否重設密碼
			  * @return none
    		*/
			resetPassword: function(reset) {
				this.profile.checkNewPW = '';	
				this.profile.newPW = '';
				this.isResetPW = reset;
				if(!reset) {
					document.getElementById("profile-table").style.height = "500px";
				} else {
					document.getElementById("profile-table").style.height = "620px";
				}
			},
			/**
			  * savePassword 儲存密碼
			  * @return none
    		*/
			savePassword: function() {
				if(this.profile.newPW === '') {
					document.getElementById("password").style.border = "1px solid Red";
					document.getElementById("check-password").style.border = "1px solid #EEEEEE";
					this.showHint('新密碼不能為空!');
					return;
				}

				if(this.profile.newPW !== this.profile.checkNewPW) {
					document.getElementById("password").style.border = "1px solid #EEEEEE";
					document.getElementById("check-password").style.border = "1px solid Red";
					this.showHint('輸入的密碼需一致');
					return;	
				}
				
				API.editPassword(this.profile.checkNewPW).then((result) => {
					if(result.status) {
						redirectLogin(result.data);
						if(!JSON.parse(result.request.response).error_msg) {
							this.showHint('重設密碼錯誤!');
						} else {
							this.showHint(JSON.parse(result.request.response).error_msg);	
						}
					} else {
						this.showHint('更改密碼成功!');
						document.getElementById("check-password").style.border = "1px solid #EEEEEE";
						document.getElementById("profile-table").style.height = "500px";
						this.isResetPW = false;
					}
				});
			},
			/**
			  * prevent keyevent預防
			  * @return none
    		*/
			prevent: function(e) {
				if(e.keyCode === 13) {
					e.preventDefault();
				}
			},
			/**
				* closeHint close hint 視窗
				* @return none
				*/
			closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.profile = false;
				clearTimeout(this.timer);
			},
			/**
				* showHint 
				* @param  {string} message - message
				* @return none
				*/
			showHint: function(message) {
				if(this.timer) {
					clearTimeout(this.timer);	
				}
				this.hint.display = true;
				this.hint.message = message;	
				this.$store.state.showHint = true;
				this.$store.state.hintStatus.profile = true;
				this.timer = setTimeout(()=>{
					if(this.$store.state.showHint) {
						this.$store.state.showHint = false;
						this.$store.state.hintStatus.info = false;
					}
				}, this.$store.state.fadeOutTime);
			},
		},
	}
</script>

<style lang="scss">
$font-color: #222222;
$font-color2: #1D2327;
$font-color3: #515151;
$border-color: #D5D5D4;
$border-color2: #EEEEEE;
$button-color: #2E90F4;

.profile {
	margin-top : 70px;
	.profile-table {
		background-color: white;
		border: $border-color2 1px solid;
    height: 500px;
    margin-top: -20px;
		margin-bottom: -20px;
    float: left;
		.profile-head {
			margin: 10px 10px;
			line-height: 24px;
			color: $font-color2;
			font-weight: 400;
			font-size: 18px;
		}
		.profile-item {
			line-height: 24px;
			display: inline-block;
			margin-left: 3%;	
			margin-top: 20px;
			padding-bottom: 15px;	
			border-bottom: 1px solid $border-color;
			width: 94%;
			.profile-title {
				color: $font-color2;
				font-weight: 400;
				font-size: 16px;
				width: 30%;
				float: left;
			}
			.profile-name {
				color: $font-color3;
				font-weight: 400;
				font-size: 16px;
				width: 70%;
				display: initial;
			}
			.password-input {
				margin-top: 4px;
				background-color: white;
				border-radius: 2px;
				border: 1px solid $border-color2;
				height: 36px;
				width: 100%;
				font-size: 14px;
				padding-left: 10px;
			}
			.reset-btn {
				display: inline-block;
	    	background: white;
				border-radius: 2px;
				color: $button-color;
				font-size: 14px;
				height: 36px;
				margin-top: -4px;
				border: 1px solid $button-color;
				width: 92px;
			}	
			.cancel-btn {
				display: block;
	    	background: white;
				border-radius: 2px;
				color: $button-color;
				font-size: 14px;
				height: 36px;
				margin-top: 12px;
				border: 1px solid $button-color;
				width: 92px;
				margin-right: 10px; 
				float: right;
			}		
			.save-btn {
				display: block;
	    	background: $button-color;
				border-radius: 2px;
				color: white;
				font-size: 14px;
				height: 36px;
				margin-top: 12px;
				border: 1px solid $button-color;
				width: 92px;
				float: right;
			}				
		}
	}
}
</style>


// WEBPACK FOOTER //
// Profile.vue?b9a791fc